<template>
    <v-container fluid>
        <v-toolbar class="elevation-0" height="48px">
            <!--<v-toolbar-title >Liste</v-toolbar-title>-->
            <v-spacer></v-spacer>
            <v-btn outlined rounded small :color="'green'" @click="switchTab('11')">
                Ajouter<v-icon>mdi-playlist-edit</v-icon>
            </v-btn>
        </v-toolbar>
        <v-timeline>
            <v-timeline-item v-for="item in itemList" :key="item.hea_id" color="red lighten-2" large >
            <template v-slot:opposite>
                <span>{{ $date(item.hea_treatment_date).format('DD MMMM YYYY') }}</span>
            </template>
            <v-card class="elevation-2" style="cursor:pointer" @click="switchTab('11', item.hea_id)">
                <v-card-title class="text-h5">
                {{ item.hea_label }} ({{ typeListById[item.hea_typ_id].typ_name }})
                </v-card-title>
                <v-card-text>
                {{ item.hea_product }} : {{ item.hea_dose }} {{ typeListById[item.hea_typ_id_dose].typ_name }}
                </v-card-text>
            </v-card>
            </v-timeline-item>
        </v-timeline>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useHealthrecordStore } from '@/stores/healthrecord'

import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'

export default {
    name: 'healthrecords-timeline',
    props: ['livestock', 'switchTab'],
    computed: {
        ...mapState(useHealthrecordStore, {itemList: 'itemList' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
    },
    data: function () {
        return {
            search: '',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            headers: [
                { text: 'Date traitement', value: 'hea_treatment_date', align: 'left'},
                { text: 'Bétail', value: 'hea_lst_id', align: 'left'},
                { text: 'Produit', value: 'hea_product', align: 'left'},
                { text: 'Libellé', value: 'hea_label', align: 'left'},
                { text: 'Statut', value: 'hea_sta_id', align: 'left'},
                { text: 'Action', value: 'hea_id', align: 'right'},
            ],
        }
    },
    async mounted () {
        await this.fetchItems('?per_page=false&hea_lst_id=' + this.livestock.lst_id)
    },
    methods: {
        ...mapActions(useHealthrecordStore, {fetchItems: 'fetchItems'}),
    },
}
</script>